import { PageHeader } from '@celltrak/ui-components';

import BusinessList from '../BusinessList';
import BusinessFilterBar from '../BusinessFilterBar';

import useBusinessSummary from './hooks';
import styles from './BusinessSummary.module.scss';

const BusinessSummary = () => {
  const { businessReports, isLoading } = useBusinessSummary();

  return (
    <div className={styles.businessSummaryContainer}>
      <div className={styles.headerContainer}>
        <PageHeader title="Business Summary Report" />
        <BusinessFilterBar />
      </div>
      <BusinessList businessReports={businessReports} loading={isLoading} />
    </div>
  );
};

export default BusinessSummary;
